"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var RegExpUtil_1 = __importDefault(require("./RegExpUtil"));
var BrowserUtil_1 = __importDefault(require("./BrowserUtil"));
var PathUtil = /** @class */ (function () {
    function PathUtil() {
    }
    PathUtil.currentPath = function () {
        return BrowserUtil_1.default.getPath();
    };
    PathUtil.prefixRegExp = function (langCode) {
        var prefix = '^/[A-Za-z]{2}/';
        if (langCode) {
            prefix = "^/" + langCode + "/";
        }
        return prefix;
    };
    PathUtil.isCatalogPage = function (path, langCode) {
        if (path === void 0) { path = PathUtil.currentPath(); }
        if (langCode === void 0) { langCode = 'ja'; }
        var pattern = PathUtil.prefixRegExp(langCode) + "co/([0-9]*)/catalog/.*";
        return RegExpUtil_1.default.test(pattern, path);
    };
    PathUtil.isSearchCatalogPage = function (path, langCode) {
        if (path === void 0) { path = PathUtil.currentPath(); }
        if (langCode === void 0) { langCode = 'ja'; }
        var pattern = PathUtil.prefixRegExp(langCode) + "s\\/catalog.*";
        return RegExpUtil_1.default.test(pattern, path);
    };
    return PathUtil;
}());
exports.default = PathUtil;
//# sourceMappingURL=PathUtil.js.map